import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react'

const FavViewFilter = ({ data, handleViewClick, activeColumn }: any) => {

    const [checked, setChecked] = useState<any>([])

    const handleClick = (value: any) => {
        const clonedChecked = cloneDeep(checked);

        const index = clonedChecked.indexOf(value);
        if (index == -1) clonedChecked.push(value)
        else clonedChecked.splice(index, 1)

        setChecked(clonedChecked)
        handleViewClick({ selected: clonedChecked, activeColumn })
    }

    return (
        <>
            <div className="border border-[#D0D5DD] rounded-lg py-4 px-4 bg-[#fff] w-full max-w-[332px] flex-shrink-0">
                <p className='text-lg font-interSemiBold text-[#101828] pb-2 border-b border-[#EAECF0] mb-4'>View</p>

                <ul>
                    {
                        data?.length > 0 && data.map((dt: any, index: number) => (
                            <li className='mb-5 last:mb-0 custom-checkbox' key={index}>
                                <input className="" type="checkbox" id={dt.value} name="radio-group" onChange={() => handleClick(dt.value)} />
                                <label className='' htmlFor={dt.value}>
                                    <span className='text-base font-interSemiBold text-[#344054] ml-2 hover:text-[#1e0af5]'>{dt.title}</span>
                                </label>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </>
    )
}

export default FavViewFilter